import { createContext } from 'react';

const LanguageContext = createContext('he');

export default LanguageContext;
